import React from 'react';
import './RusStat.css'

interface Props {
   statTwo: number;
   text: string;
   img: string;
}


const RusBlock: React.FC<Props> = ({ statTwo, text, img }) => {

   return (
      <div className='rus_stat'>
         <img src={img} alt="" />
         <span>{text}</span>
         <span style={{ color: "var(--primary-color)", fontFamily: 'var(--primary-ff)', fontSize: '1.4rem' }}  >
            {statTwo}
         </span>
      </div>

   )
}


export default RusBlock;